// src/components/Footer.js
import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 CST System. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
